<template>
    <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
      <div class="delete-modal">
        <div class="flex justify-center">
          <svg width="100" height="91" viewBox="0 0 100 91" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 36.8285V43.6321L50 77.161L49.9785 77.1749L0 43.6321V36.8285L13.8379 27.2769H86.1621L100 36.8285Z" fill="#186A81"/>
            <path d="M100 36.8285V43.6321L50 77.1609V27.2769H86.1621L100 36.8285Z" fill="#00465F"/>
            <path d="M87.3047 0.701172V53.228L50.0234 75.3615L50 75.3475L12.6953 53.2211V0.701172L87.3047 0.701172Z" fill="#EAF4F4"/>
            <path d="M87.3047 0.701172V53.228L50.0234 75.3615L50 75.3475V0.701172L87.3047 0.701172Z" fill="#CAE8EA"/>
            <path d="M100 48.8896V90.7012H0V43.6318L49.9785 71.917L50.0234 71.9432L100 48.8896Z" fill="#FFE26F"/>
            <path d="M100 43.6318V90.7012H49.9785V71.917L50.0234 71.9432L100 43.6318Z" fill="#FFC271"/>
            <path d="M50 57.2572C63.6539 57.2572 74.7226 47.2953 74.7226 35.0068C74.7226 22.7182 63.6539 12.7563 50 12.7563C36.346 12.7563 25.2773 22.7182 25.2773 35.0068C25.2773 47.2953 36.346 57.2572 50 57.2572Z" fill="#00DC7B"/>
            <path d="M74.7226 35.0068C74.7226 47.2763 63.6328 57.2572 50 57.2572V12.7563C63.6328 12.7563 74.7226 22.7372 74.7226 35.0068Z" fill="#00AA8E"/>
            <path d="M61.0742 31.094L47.4551 43.3513L38.9258 35.6749L43.0684 31.9466L47.4551 35.8946L50 33.6042L56.9316 27.3657L61.0742 31.094Z" fill="white"/>
            <path d="M61.0742 31.094L50 41.0608V33.6042L56.9316 27.3657L61.0742 31.094Z" fill="#EAF4F4"/>
          </svg>
        </div>
  
        <div class="my-6">
          <p>Your request has been successfully submitted. Our team will contact you shortly. </p>
        </div>
          <div>
            <base-button @click="closeModal()" text="Continue" />
          </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data(){
      return {
        showDeclineReasonModal: false
      }
    },

    methods: {
      closeModal() {
        this.showDeclineReasonModal = true
        this.$emit("close-modal");
      },
    }
  };
  </script>
  
  <style scoped>
  .delete-modal {
    text-align: center;
  }
  </style>
  